import axios from 'axios';
import { setAuthData, getAuthData } from './authData';
import get from 'lodash.get';

const getURL = () => {
  // development
  // if (process.env.NODE_ENV === 'development')
  //   return 'http://localhost:4000/api';
  // staging
  // if (window.location.origin.includes('beta-app'))
  //   return 'https://purify.brocoders.xyz/api';
  // production
  return process.env.REACT_APP_API_ENDPOINT;
};

const instance = axios.create({
  baseURL: getURL(),
});

/* request interceptor */
instance.interceptors.request.use(function(request) {
  Object.assign(request.headers, getAuthData());
  return request;
});

/* response interceptor */
instance.interceptors.response.use(
  ({ headers, data }) => {
    if (headers['access-token']) setAuthData(headers);
    return data;
  },
  (responseData = {}) => {
    const { response, message } = responseData;
    const data = get(response, 'data');
    const status = get(response, 'status');

    if (data && data['access-token']) setAuthData(data);
    return Promise.reject({ data, message, status });
  }
);

export default instance;



// WEBPACK FOOTER //
// ./src/utils/client.js